/**
 * dataLayer.push() is for gtm
 * utag.link() is for tealium
 */
const analyticsComposable = {
    trackEvent: function (eventObject) {
        if (typeof window !== "undefined" && window !== null) {
            if (window.dataLayer) {
                window.dataLayer.push(eventObject);
            }
            if (window.utag) {
                // @ts-ignore
                window.utag.link(eventObject);
            }
        }
    },
    trackLinkEvent: function (type, region, section, text, component) {
        const eventObject = {
            event: "link",
            name: "onclick",
            action: "click",
            type: type,
            region: region,
            section: section,
            text: text,
            component: component,
        };
        this.trackEvent(eventObject);
    },
    trackSelectEvent: function (name, action, type, region, section, text, component) {
        const eventObject = {
            event: "select",
            name: name,
            action: action,
            type: type,
            region: region,
            section: section,
            text: text,
            component: component,
        };
        this.trackEvent(eventObject);
    },
    trackFormEvent: function (name, action, type, region, section, text, component) {
        const eventObject = {
            event: "form",
            name: name,
            action: action,
            type: type,
            region: region,
            section: section,
            text: text,
            component: component,
        };
        this.trackEvent(eventObject);
    },
    trackModalEvent: function (name, action, type, region, section, text, component) {
        const eventObject = {
            event: "modal",
            name: name,
            action: action,
            type: type,
            region: region,
            section: section,
            text: text,
            component: component,
        };
        this.trackEvent(eventObject);
    },
    trackCollapseEvent: function (name, action, type, region, section, text, component) {
        const eventObject = {
            event: "collapse",
            name: name,
            action: action,
            type: type,
            region: region,
            section: section,
            text: text,
            component: component,
        };
        this.trackEvent(eventObject);
    },
};
export { analyticsComposable };
